module.exports = __webpack_public_path__ + "img/basic_bg.a7caadf7.png";